module.exports = __webpack_public_path__ + "assets/lessons/en/lesson5/modals/lesson_5_3_a.pdf";